import { portalEnv, FirebaseEnvConfig } from '../config/portalEnv';

const buildMessagingServiceWorkerScript = (config: FirebaseEnvConfig): string => `
importScripts('https://www.gstatic.com/firebasejs/9.6.1/firebase-app-compat.js');
importScripts('https://www.gstatic.com/firebasejs/9.6.1/firebase-messaging-compat.js');
firebase.initializeApp(${JSON.stringify(config)});
firebase.messaging();
self.addEventListener('push', function (event) {
  if (!event.data) return;
  const payload = event.data.json();
  const data = payload.data || {};
  const title = data.title || 'No Title';
  const body = data.body || 'No Body';
  const icon = data.imageUrl || '/default-icon.png';
  const url = data.url || '';
  event.waitUntil(
    self.registration.showNotification(title, {
      body: body,
      icon: icon,
      data: { url: url },
    })
  );
});
self.addEventListener('notificationclick', function (event) {
  event.notification.close();
  const url = event.notification.data && event.notification.data.url;
  if (url) event.waitUntil(clients.openWindow(url));
});
`;

let registrationPromise: Promise<ServiceWorkerRegistration | null> | null = null;

/** Registers FCM service worker using Firebase config from Portal/.env (via portalEnv). */
export const registerFirebaseMessagingServiceWorker =
  async (): Promise<ServiceWorkerRegistration | null> => {
    if (!('serviceWorker' in navigator)) return null;

    if (!registrationPromise) {
      registrationPromise = (async () => {
        try {
          const existing = await navigator.serviceWorker.getRegistrations();
          const fcmReg = existing.find((r) =>
            r.active?.scriptURL?.includes('firebase-messaging')
          );
          if (fcmReg?.active) return fcmReg;

          const script = buildMessagingServiceWorkerScript(portalEnv.firebase);
          const blob = new Blob([script], { type: 'application/javascript' });
          const blobUrl = URL.createObjectURL(blob);
          return await navigator.serviceWorker.register(blobUrl, { scope: '/' });
        } catch (err) {
          console.error('Firebase messaging service worker registration failed:', err);
          return null;
        }
      })();
    }

    return registrationPromise;
  };
